module.exports = __webpack_public_path__ + "media/images/hsbc-logo-light-3b8d9ea83132393618a4267f07495efe.svg";